import AlertCircleFilled from '../../assets/AlertCircleFilled.svg?react';
import CheckCircleFilled from '../../assets/CheckCircleFilled.svg?react';
import InfoCircleFilled from '../../assets/InfoCircleFilled.svg?react';
import WarningFilled from '../../assets/WarningFilled.svg?react';

import type { Config, Level } from './types';
import type { TypeOptions } from 'react-toastify';

export const config: { [key in Level]: Config } = {
  info: {
    RawIcon: InfoCircleFilled,
    containerClassnames: 'outline-strong-info ctn-info-weak',
    iconClassnames: 'icon-info-strong',
  },
  success: {
    RawIcon: CheckCircleFilled,
    containerClassnames: 'outline-strong-success ctn-success-weak',
    iconClassnames: 'icon-success-strong',
  },
  warning: {
    RawIcon: AlertCircleFilled,
    containerClassnames: 'outline-strong-warning ctn-warning-weak',
    iconClassnames: 'icon-warning-strong',
  },
  error: {
    RawIcon: WarningFilled,
    containerClassnames: 'outline-strong-danger ctn-danger-weak',
    iconClassnames: 'icon-danger-strong',
  },
};

export const toastContainerContextClass: { [key in TypeOptions]: string } = {
  info: config.info.containerClassnames,
  success: config.success.containerClassnames,
  warning: config.warning.containerClassnames,
  error: config.error.containerClassnames,
  default: '',
};
